var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-overlay',{staticClass:"jloading",attrs:{"show":_vm.show,"z-index":"999"}},[_c('div',{staticClass:"loadingwrap"},[_c('van-loading',{attrs:{"type":"spinner"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }